import * as React from 'react'

import './PlayButtonViewStyles.scss';

const PlayButtonView = (props:any) => {
    return (
        <div className="livescorePlay">
            <div className={ `
              livescorePlayButton
              ${ isChannelActive( props.active ) }` }>
            </div>
        </div>
    )
}

// check if channel is active or not
const isChannelActive = (isActive:boolean) => isActive ? 'highlight' : ''

export default PlayButtonView
